var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: {
        bus: _vm.busModal,
        persistent: "",
        centerScreen: "",
        maxWidth: _vm.maxWidth
      },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function(ref) {
            var close = ref.close
            return [
              _c("v-spacer"),
              _c(
                "BaseButton",
                { attrs: { underlined: "" }, on: { click: close } },
                [_vm._v(" Cancelar ")]
              ),
              _c(
                "BaseButton",
                {
                  attrs: {
                    primary: _vm.campo !== "excluir",
                    alert: _vm.campo === "excluir",
                    loading: _vm.loading
                  },
                  on: { click: _vm.salvar }
                },
                [_vm._v(" " + _vm._s(_vm.buttonOptions) + " ")]
              ),
              _c("v-spacer")
            ]
          }
        }
      ])
    },
    [
      _c("Title", {
        attrs: {
          title: _vm.title,
          subtitle: _vm.ativos.length + " ativos selecionados"
        }
      }),
      _c(
        "v-form",
        {
          ref: "form",
          on: {
            submit: function($event) {
              $event.preventDefault()
            }
          }
        },
        [
          _c(
            "div",
            [
              _vm.campo === "classe"
                ? [
                    _c("v-select", {
                      attrs: {
                        label: "Classe*",
                        placeholder: "Selecione a classe*",
                        items: _vm.CLASSES_SIMULADOR,
                        rules: [_vm.rules.required]
                      },
                      model: {
                        value: _vm.classe,
                        callback: function($$v) {
                          _vm.classe = $$v
                        },
                        expression: "classe"
                      }
                    })
                  ]
                : _vm._e(),
              _vm.campo === "subclasse"
                ? [
                    !_vm.modoIndividual
                      ? [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "6" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      label: "Classe*",
                                      placeholder: "Selecione a classe*",
                                      items: _vm.CLASSES_SIMULADOR,
                                      rules: [_vm.rules.required],
                                      "menu-props": { offsetY: true }
                                    },
                                    on: { change: _vm.onClasseLoteChange },
                                    model: {
                                      value: _vm.classeLote,
                                      callback: function($$v) {
                                        _vm.classeLote = $$v
                                      },
                                      expression: "classeLote"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "6" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      label: "Subclasse",
                                      items: _vm.subclassesLote,
                                      "item-text": "subclasse",
                                      "item-value": "subclasse",
                                      "menu-props": { offsetY: true }
                                    },
                                    on: { change: _vm.onSubclasseLoteChange },
                                    model: {
                                      value: _vm.subclasseLote,
                                      callback: function($$v) {
                                        _vm.subclasseLote = $$v
                                      },
                                      expression: "subclasseLote"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      : _vm._e(),
                    _vm.temMultiplosAtivos
                      ? _c("v-checkbox", {
                          staticClass: "mt-0 mb-4",
                          attrs: {
                            label:
                              "Preciso definir valores diferentes por ativo",
                            "hide-details": ""
                          },
                          model: {
                            value: _vm.modoIndividual,
                            callback: function($$v) {
                              _vm.modoIndividual = $$v
                            },
                            expression: "modoIndividual"
                          }
                        })
                      : _vm._e(),
                    _vm.modoIndividual
                      ? _c("v-simple-table", {
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function() {
                                  return [
                                    _c("thead", [
                                      _c("tr", [
                                        _c("th", [_vm._v("Nome ativo")]),
                                        _c(
                                          "th",
                                          { staticStyle: { width: "250px" } },
                                          [_vm._v("Classe")]
                                        ),
                                        _c(
                                          "th",
                                          { staticStyle: { width: "250px" } },
                                          [_vm._v("Subclasse")]
                                        )
                                      ])
                                    ]),
                                    _c(
                                      "tbody",
                                      _vm._l(_vm.ativos, function(
                                        ativo,
                                        index
                                      ) {
                                        return _c(
                                          "tr",
                                          {
                                            key: index,
                                            staticClass:
                                              "acoes-lote-ativos-consolidador__row"
                                          },
                                          [
                                            _c("td", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    ativo.nome_ativo || "—"
                                                  ) +
                                                  " "
                                              )
                                            ]),
                                            _c(
                                              "td",
                                              [
                                                _c("v-select", {
                                                  attrs: {
                                                    label: "Classe*",
                                                    placeholder:
                                                      "Selecione a classe*",
                                                    items:
                                                      _vm.CLASSES_SIMULADOR,
                                                    rules: [_vm.rules.required],
                                                    "menu-props": {
                                                      offsetY: true
                                                    }
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      return _vm.calcSubclassesAtivo(
                                                        ativo,
                                                        $event
                                                      )
                                                    }
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "append",
                                                        fn: function() {
                                                          return [
                                                            _vm.temMultiplosAtivos
                                                              ? _c(
                                                                  "v-tooltip",
                                                                  {
                                                                    attrs: {
                                                                      bottom:
                                                                        "",
                                                                      "open-delay":
                                                                        "150"
                                                                    },
                                                                    scopedSlots: _vm._u(
                                                                      [
                                                                        {
                                                                          key:
                                                                            "activator",
                                                                          fn: function(
                                                                            ref
                                                                          ) {
                                                                            var on =
                                                                              ref.on
                                                                            var attrs =
                                                                              ref.attrs
                                                                            return [
                                                                              _c(
                                                                                "v-btn",
                                                                                _vm._g(
                                                                                  _vm._b(
                                                                                    {
                                                                                      staticClass:
                                                                                        "acoes-lote-ativos-consolidador__apply-btn",
                                                                                      attrs: {
                                                                                        icon:
                                                                                          "",
                                                                                        "x-small":
                                                                                          "",
                                                                                        ripple: false
                                                                                      },
                                                                                      on: {
                                                                                        click: function(
                                                                                          $event
                                                                                        ) {
                                                                                          $event.stopPropagation()
                                                                                          return _vm.applyClasseToAll(
                                                                                            index
                                                                                          )
                                                                                        }
                                                                                      }
                                                                                    },
                                                                                    "v-btn",
                                                                                    attrs,
                                                                                    false
                                                                                  ),
                                                                                  on
                                                                                ),
                                                                                [
                                                                                  _c(
                                                                                    "v-icon",
                                                                                    {
                                                                                      attrs: {
                                                                                        small:
                                                                                          ""
                                                                                      }
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "mdi-arrow-down"
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ],
                                                                                1
                                                                              )
                                                                            ]
                                                                          }
                                                                        }
                                                                      ],
                                                                      null,
                                                                      true
                                                                    )
                                                                  },
                                                                  [
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        "Aplicar aos próximos ativos"
                                                                      )
                                                                    ])
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _c("v-icon", [
                                                              _vm._v(
                                                                "mdi-menu-down"
                                                              )
                                                            ])
                                                          ]
                                                        },
                                                        proxy: true
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                  model: {
                                                    value: ativo.classe,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        ativo,
                                                        "classe",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "ativo.classe"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "td",
                                              [
                                                _c("v-select", {
                                                  attrs: {
                                                    label: "Subclasse",
                                                    items:
                                                      _vm.subclasses_ativos[
                                                        ativo.id
                                                      ],
                                                    "item-text": "subclasse",
                                                    "item-value": "subclasse",
                                                    "menu-props": {
                                                      offsetY: true
                                                    }
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "append",
                                                        fn: function() {
                                                          return [
                                                            _vm.temMultiplosAtivos
                                                              ? _c(
                                                                  "v-tooltip",
                                                                  {
                                                                    attrs: {
                                                                      bottom:
                                                                        "",
                                                                      "open-delay":
                                                                        "150"
                                                                    },
                                                                    scopedSlots: _vm._u(
                                                                      [
                                                                        {
                                                                          key:
                                                                            "activator",
                                                                          fn: function(
                                                                            ref
                                                                          ) {
                                                                            var on =
                                                                              ref.on
                                                                            var attrs =
                                                                              ref.attrs
                                                                            return [
                                                                              _c(
                                                                                "v-btn",
                                                                                _vm._g(
                                                                                  _vm._b(
                                                                                    {
                                                                                      staticClass:
                                                                                        "acoes-lote-ativos-consolidador__apply-btn",
                                                                                      attrs: {
                                                                                        icon:
                                                                                          "",
                                                                                        "x-small":
                                                                                          "",
                                                                                        ripple: false
                                                                                      },
                                                                                      on: {
                                                                                        click: function(
                                                                                          $event
                                                                                        ) {
                                                                                          $event.stopPropagation()
                                                                                          return _vm.applySubclasseToFollowing(
                                                                                            index
                                                                                          )
                                                                                        }
                                                                                      }
                                                                                    },
                                                                                    "v-btn",
                                                                                    attrs,
                                                                                    false
                                                                                  ),
                                                                                  on
                                                                                ),
                                                                                [
                                                                                  _c(
                                                                                    "v-icon",
                                                                                    {
                                                                                      attrs: {
                                                                                        small:
                                                                                          ""
                                                                                      }
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "mdi-arrow-down"
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ],
                                                                                1
                                                                              )
                                                                            ]
                                                                          }
                                                                        }
                                                                      ],
                                                                      null,
                                                                      true
                                                                    )
                                                                  },
                                                                  [
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        "Aplicar aos próximos ativos"
                                                                      )
                                                                    ])
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _c("v-icon", [
                                                              _vm._v(
                                                                "mdi-menu-down"
                                                              )
                                                            ])
                                                          ]
                                                        },
                                                        proxy: true
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                  model: {
                                                    value: ativo.subclasse,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        ativo,
                                                        "subclasse",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "ativo.subclasse"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            2659218051
                          )
                        })
                      : _vm._e()
                  ]
                : _vm._e(),
              _vm.campo === "instituicao"
                ? [
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "12" } },
                          [
                            _c("v-select", {
                              attrs: {
                                items: _vm.contas,
                                label: _vm.$currentUser().IS_CLIENTE
                                  ? "Selecione a sua conta*"
                                  : "Selecione a conta do cliente*",
                                "item-text": function(item) {
                                  return item.num_conta
                                    ? item.num_conta + " - " + item.label
                                    : item.label
                                },
                                required: "",
                                rules: [_vm.rules.required],
                                loading: _vm.loading_accounts,
                                "return-object": ""
                              },
                              model: {
                                value: _vm.conta,
                                callback: function($$v) {
                                  _vm.conta = $$v
                                },
                                expression: "conta"
                              }
                            })
                          ],
                          1
                        ),
                        _vm.conta.label === "Outros"
                          ? _c(
                              "v-col",
                              { attrs: { cols: "12" } },
                              [
                                _c("v-combobox", {
                                  attrs: {
                                    label: "Selecionar instituição*",
                                    items: _vm.listaInstituicoes,
                                    autocomplete: "off",
                                    "item-text":
                                      _vm.apiInstituicoes.formatarTexto,
                                    filter: _vm.apiInstituicoes.filtrar,
                                    "menu-props": {
                                      closeOnContentClick: true
                                    },
                                    rules: [_vm.rules.required]
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "prepend-item",
                                        fn: function() {
                                          return [
                                            _c(
                                              "v-list-item",
                                              [
                                                _c(
                                                  "v-list-item-content",
                                                  [
                                                    _c("v-list-item-title", [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "text-primary mb-0"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " Escolher Instituição "
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        },
                                        proxy: true
                                      },
                                      {
                                        key: "no-data",
                                        fn: function() {
                                          return [_c("v-divider")]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    false,
                                    1735611017
                                  ),
                                  model: {
                                    value: _vm.novaInstituicao,
                                    callback: function($$v) {
                                      _vm.novaInstituicao = $$v
                                    },
                                    expression: "novaInstituicao"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.novaInstituicao && _vm.novaInstituicao.id_banco
                          ? _c(
                              "v-col",
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    label: "Identificador da conta (opcional)",
                                    hint: "Número da conta, e-mail ou CPF"
                                  },
                                  model: {
                                    value: _vm.novaInstituicaoConta,
                                    callback: function($$v) {
                                      _vm.novaInstituicaoConta = $$v
                                    },
                                    expression: "novaInstituicaoConta"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              _vm.campo === "portfolio"
                ? [
                    _c("v-combobox", {
                      ref: "combo_nome_portfolio",
                      attrs: {
                        label: "Portfólio",
                        items: _vm.sugestoesPortfolios,
                        autocomplete: "off"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "prepend-item",
                            fn: function() {
                              return [
                                _c("div", { staticClass: "p-5" }, [
                                  _c("p", { staticClass: "subtitle" }, [
                                    _vm._v(" SUGESTÕES ENCONTRADAS ")
                                  ])
                                ])
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        4260839202
                      ),
                      model: {
                        value: _vm.portfolio,
                        callback: function($$v) {
                          _vm.portfolio = $$v
                        },
                        expression: "portfolio"
                      }
                    })
                  ]
                : _vm._e(),
              _vm.campo === "comentario"
                ? [
                    _c("p", [
                      _vm._v(
                        " Atenção: este comentário irá sobrescrever os comentários atuais em cada ativo. "
                      )
                    ]),
                    _c("v-textarea", {
                      attrs: { label: "Novo comentário" },
                      model: {
                        value: _vm.comentario,
                        callback: function($$v) {
                          _vm.comentario = $$v
                        },
                        expression: "comentario"
                      }
                    })
                  ]
                : _vm._e(),
              _vm.campo === "tag"
                ? [
                    _c(
                      "div",
                      [
                        _c("p", [
                          _vm._v(
                            " As tags selecionadas abaixo serão adicionadas nos ativos, para remover as tags atuais é necessário editar individualmente cada ativo. "
                          )
                        ]),
                        _c("TagField", {
                          model: {
                            value: _vm.tag,
                            callback: function($$v) {
                              _vm.tag = $$v
                            },
                            expression: "tag"
                          }
                        })
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              _vm.campo === "simulacao"
                ? [
                    _c("p", [_vm._v(" Selecione o modo do simulador: ")]),
                    _c(
                      "v-list",
                      [
                        _c(
                          "v-list-item",
                          {
                            on: {
                              click: function($event) {
                                return _vm.enviarSimulacao("manual")
                              }
                            }
                          },
                          [
                            _c(
                              "v-list-item-icon",
                              [
                                _c("v-icon", [
                                  _vm._v(" mdi-hand-back-left-outline ")
                                ])
                              ],
                              1
                            ),
                            _c("v-list-item-title", [_vm._v(" Manual ")])
                          ],
                          1
                        ),
                        _c(
                          "v-list-item",
                          {
                            on: {
                              click: function($event) {
                                return _vm.enviarSimulacao("automatico")
                              }
                            }
                          },
                          [
                            _c(
                              "v-list-item-icon",
                              [_c("v-icon", [_vm._v(" mdi-rocket ")])],
                              1
                            ),
                            _c("v-list-item-title", [_vm._v(" Automático ")])
                          ],
                          1
                        ),
                        _c(
                          "v-list-item",
                          {
                            on: {
                              click: function($event) {
                                return _vm.enviarSimulacao("guiado")
                              }
                            }
                          },
                          [
                            _c(
                              "v-list-item-icon",
                              [
                                _c("v-icon", [_vm._v(" mdi-transit-transfer ")])
                              ],
                              1
                            ),
                            _c("v-list-item-title", [_vm._v(" Guiado ")])
                          ],
                          1
                        ),
                        _c(
                          "v-list-item",
                          {
                            on: {
                              click: function($event) {
                                return _vm.enviarSimulacao("avancado")
                              }
                            }
                          },
                          [
                            _c(
                              "v-list-item-icon",
                              [_c("v-icon", [_vm._v(" mdi-tune-vertical ")])],
                              1
                            ),
                            _c("v-list-item-title", [_vm._v(" Avançado ")])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              _vm.campo === "isento_fee"
                ? [
                    _c("p", [
                      _vm._v(
                        " Definir os ativos como isentos no cálculo de Fee? "
                      )
                    ]),
                    _c("v-checkbox", {
                      attrs: { label: "Isento no Fee" },
                      model: {
                        value: _vm.isento_fee,
                        callback: function($$v) {
                          _vm.isento_fee = $$v
                        },
                        expression: "isento_fee"
                      }
                    })
                  ]
                : _vm._e(),
              _vm.campo === "isento_ir"
                ? [
                    _c("p", [
                      _vm._v(" Definir os ativos como isentos de IR? ")
                    ]),
                    _c("v-checkbox", {
                      attrs: { label: "Isento de IR" },
                      model: {
                        value: _vm.isento_ir,
                        callback: function($$v) {
                          _vm.isento_ir = $$v
                        },
                        expression: "isento_ir"
                      }
                    })
                  ]
                : _vm._e(),
              _vm.campo === "desconsiderar_rentabilidade"
                ? [
                    _c("p", [
                      _vm._v(
                        " Definir os ativos para serem desconsiderados na rentabilidade da carteira? "
                      )
                    ]),
                    _c("v-checkbox", {
                      attrs: { label: "Excluir da rentabilidade da carteira" },
                      model: {
                        value: _vm.desconsiderar_rentabilidade,
                        callback: function($$v) {
                          _vm.desconsiderar_rentabilidade = $$v
                        },
                        expression: "desconsiderar_rentabilidade"
                      }
                    })
                  ]
                : _vm._e(),
              _vm.campo === "excluir"
                ? [
                    _c("Warning", {
                      attrs: { type: "break" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "description",
                            fn: function() {
                              return [
                                _vm._v(
                                  "Você irá excluir permanentemente " +
                                    _vm._s(_vm.ativos.length) +
                                    " ativo(s) e suas movimentações. Você tem certeza?"
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        1089321603
                      )
                    }),
                    _c(
                      "v-expansion-panels",
                      { staticClass: "mb-3" },
                      [
                        _c(
                          "v-expansion-panel",
                          [
                            _c("v-expansion-panel-header", [
                              _vm._v(" Ativos ")
                            ]),
                            _c(
                              "v-expansion-panel-content",
                              [
                                _c("v-simple-table", {
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function() {
                                          return [
                                            _c("thead", [_c("tr")]),
                                            _c(
                                              "tbody",
                                              _vm._l(_vm.ativos, function(
                                                ativo,
                                                index
                                              ) {
                                                return _c(
                                                  "tr",
                                                  { key: index },
                                                  [
                                                    _c("td", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            ativo.nome_ativo ||
                                                              "—"
                                                          ) +
                                                          " "
                                                      )
                                                    ])
                                                  ]
                                                )
                                              }),
                                              0
                                            )
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    false,
                                    1622878940
                                  )
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                : _vm._e()
            ],
            2
          )
        ]
      ),
      _vm.erros.length
        ? _c(
            "div",
            {
              staticStyle: {
                "max-height": "200px",
                "overflow-y": "auto",
                "overflow-x": "hidden"
              }
            },
            [
              _c("p", { staticClass: "subtitle" }, [_vm._v(" ALERTAS: ")]),
              _vm._l(_vm.erros, function(erro, index) {
                return [
                  _c("p", { key: index, staticClass: "mb-0 ml-2" }, [
                    _c("small", [_vm._v(" " + _vm._s(erro.message) + " ")])
                  ])
                ]
              })
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }